import { useTranslation } from '../../../../i18n';
import type { ReactElement } from 'react';
import type { RichTextProps } from '../types';

import './style.less';

export function RichTextComponent(props: RichTextProps): ReactElement {
  const [t] = useTranslation();

  const defaultValue = (props.specification == null || props.specification === '')
    ? `<span style="">${t('无')}</span>`
    : props.specification;

  return (
    <div
      // 保留原有样式，不使用module
      className='ql-editors'
      data-gramm='false'
      dangerouslySetInnerHTML={{ __html: defaultValue }}
    />
  );
}
